export default {
    name: "Logo"
}